import { ReactNode } from "react";
import { Box, FormControlLabel, Typography as T } from "@mui/material";

import { Radio, RequiredStar } from "components/atoms";

type Props = {
  checked: boolean;
  labelText: ReactNode;
  children?: ReactNode;
  required?: boolean;
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const RadioButtons = ({
  value,
  labelText,
  children,
  required,
  handleChange,
  checked,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FormControlLabel
        control={
          <Radio value={value} onChange={handleChange} checked={checked} />
        }
        label={
          <Box
            sx={{
              position: "relative",
            }}
          >
            <T
              sx={required ? { paddingLeft: 1 } : {}}
              variant={checked ? "h3" : "h5md"}
            >
              {labelText}
            </T>
            {required && <RequiredStar styles={{ left: "-3px" }} />}
          </Box>
        }
      />
      <Box
        sx={{
          marginLeft: 4,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default RadioButtons;
